import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VeteranVerification = ({ candidates }) => {
  const pendingVerification = candidates?.filter(c => c?.veteranStatus === 'pending_verification') || [];

  const getClearanceLevelColor = (level) => {
    switch (level) {
      case 'Top Secret': return 'error';
      case 'Secret': return 'warning';
      case 'Confidential': return 'secondary';
      default: return 'muted';
    }
  };

  return (
    <div className="glass-container rounded-xl border border-border/50">
      <div className="p-6 border-b border-border/50">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Veteran Verification</h3>
            <p className="text-sm text-muted-foreground mt-1">
              {pendingVerification?.length} candidates pending verification
            </p>
          </div>
          <Button variant="outline" size="sm" iconName="RefreshCw">
            Sync with Military DB
          </Button>
        </div>
      </div>
      <div className="p-6">
        {pendingVerification?.length === 0 ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>
            <h4 className="text-lg font-semibold text-foreground mb-2">All Caught Up!</h4>
            <p className="text-sm text-muted-foreground">
              No pending veteran verifications at this time
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {pendingVerification?.map((candidate) => (
              <div
                key={candidate?.id}
                className="p-4 rounded-lg border border-warning/20 bg-warning/5"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                      <Icon name="User" size={18} color="white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">{candidate?.name}</h4>
                      <p className="text-sm text-muted-foreground">{candidate?.email}</p>
                    </div>
                  </div>
                  <span className="px-2 py-1 rounded text-xs font-medium text-warning bg-warning/10">
                    PENDING VERIFICATION
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Military Branch</p>
                    <div className="flex items-center space-x-2">
                      <Icon name="Shield" size={14} className="text-foreground" />
                      <span className="text-sm font-medium text-foreground">{candidate?.militaryBranch}</span>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Rank</p>
                    <div className="flex items-center space-x-2">
                      <Icon name="Award" size={14} className="text-foreground" />
                      <span className="text-sm font-medium text-foreground">{candidate?.rank}</span>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Years of Service</p>
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={14} className="text-foreground" />
                      <span className="text-sm font-medium text-foreground">{candidate?.yearsOfService} years</span>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">Clearance Level</p>
                    <div className="flex items-center space-x-2">
                      <Icon name="Lock" size={14} className="text-foreground" />
                      <span className={`text-sm font-medium text-${getClearanceLevelColor(candidate?.clearanceLevel)}`}>
                        {candidate?.clearanceLevel}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center space-x-2">
                  <Button variant="default" size="sm" iconName="CheckCircle" className="flex-1">
                    Verify Veteran Status
                  </Button>
                  <Button variant="outline" size="sm" iconName="Eye">
                    View Documents
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VeteranVerification;